import $ from 'jquery';

$('.catalog-not-medicine__close').click(function () {
    $(this).parents('.catalog-not-medicine').remove();
});
